import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";

export default class CollectionHeroSwiper extends HTMLElement {
  private swiper: Swiper | null = null;

  connectedCallback() {
    // Prevent multiple initializations
    if (this.swiper) {
      return;
    }

    const $el = this.querySelector<HTMLElement>(".collection-hero__slider");
    
    if (!$el) {
      return;
    }

    // Check if Swiper is already initialized on this element
    if ((($el as any).swiper as Swiper)) {
      this.swiper = ($el as any).swiper as Swiper;
      return;
    }

    const $elPrev = this.querySelector<HTMLElement>(".collection-hero__nav-button--prev");
    const $elNext = this.querySelector<HTMLElement>(".collection-hero__nav-button--next");

    // Swiper options
    const swiperParams: any = {
      modules: [Navigation],
      slidesPerView: "auto" as const,
      slidesOffsetBefore: 20,
      spaceBetween: 8,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: "auto" as const,
          slidesOffsetBefore: 0,
          spaceBetween: 8,
          centeredSlides: false,
          loop: false,
        },
      },
    };

    // Navigation settings
    if ($elPrev && $elNext) {
      swiperParams.navigation = {
        nextEl: $elNext,
        prevEl: $elPrev,
      };
    }

    // Initialize Swiper
    this.swiper = new Swiper($el, swiperParams);
  }

  disconnectedCallback() {
    // Clean up Swiper instance when element is removed
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

